var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pdl)?_c('div',{staticClass:"pdl-detail pa-10 pt-0"},[_c('tab-navigation',{attrs:{"title":_vm.$tc('pdl.pdl'),"icon":"mdi-transmission-tower","breadcrumbs":[
        {text: _vm.pdl.organizationName, to: {name: 'organizations.pdls', params: {id: _vm.pdl.organizationId}}, exact: true},
        {text: _vm.pdlLabel},
    ]}},[_c('v-tabs',[_c('v-tab',{attrs:{"to":{name: 'pdl.detail'},"exact":""}},[_vm._v(_vm._s(_vm.$t('informations')))]),_c('v-tab',{attrs:{"to":{name: 'pdl.detail.locations'}}},[_vm._v(_vm._s(_vm.$tc('location.location', 2)))])],1)],1),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }